"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationsLoader = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _core = require("@material-ui/core");
var _translations = require("../../state/entities/translations");
var _FullPageLoader = require("../FullPageLoader");
var _AlertMessage = _interopRequireDefault(require("../AlertMessage"));
var _intl = require("../../utils/intl");
var _locale = require("../../utils/locale");
var _hooks = require("../../hooks");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const TranslationsLoader = _ref => {
  let {
    locale,
    children,
    silent: isSilent = false,
    ...props
  } = _ref;
  const {
    brandId
  } = (0, _hooks.useConfig)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const translations = (0, _reactRedux.useSelector)(_translations.translationsSelectors.values);
  const isSuccess = (0, _reactRedux.useSelector)(_translations.translationsSelectors.isSuccess);
  const errorMessage = (0, _reactRedux.useSelector)(_translations.translationsSelectors.errorMessage);
  (0, _react.useEffect)(() => {
    dispatch((0, _translations.loadTranslations)(brandId));
  }, []);
  const overriddenMessages = {
    ...translations[locale]
  };
  const renderErrorMessage = () => {
    return /*#__PURE__*/_react.default.createElement(_core.Box, {
      p: 5
    }, /*#__PURE__*/_react.default.createElement(_AlertMessage.default, {
      variant: "filled",
      text: errorMessage
    }));
  };
  if (!isSuccess && !errorMessage) {
    return isSilent ? null : /*#__PURE__*/_react.default.createElement(_FullPageLoader.FullPageLoader, null);
  }
  return /*#__PURE__*/_react.default.createElement(_reactIntl.IntlProvider, _extends({
    onError: _intl.handleTranslationError,
    locale: (0, _locale.getISOLocale)(locale),
    messages: overriddenMessages
  }, props), errorMessage ? renderErrorMessage() : children);
};
exports.TranslationsLoader = TranslationsLoader;